export const ACTIVITY_LOG_MAP = {
  siteOwnerships: "Site Ownerships",
  siteMPANs: "Site MPANs",
  buildings: "Buildings",
  totalBuildingArea: "Total Building Area",
  updatedAt: "Updated At",
  updatedBy: "Updated By",
  updatedByName: "Updated By Name",
  name: "Name",
  address: "Address",
  notes: "Notes",
  commerciallyOperationalDateEpochSeconds: "Commercially Operational Date",
  commerciallyOperationalDate: "Commercially Operational Date",
  modellingFrom: "Forecasting start date",
  modellingFromDate: "Forecasting start date",
  funderStartDate: "Funder Start Date",
  leaseLengthDateEpochSeconds: "Lease Length (Date)",
  leaseLengthDate: "Lease Length (Date)",
  postcode: "Postcode",
  latitude: "Latitude",
  longitude: "Longitude",
  annualGenerationLoss: "Annual Generation Loss",
  roofUtilization: "Roof Utilization",
  panelCostPerSqm: "Panel Cost Per SqM",
  gridConnectionCost: "Grid Connection Cost",
  marketTariff: "Market Tariff",
  tenantTariff: "Tenant Tariff",
  gridExportTariff: "Grid Export Tariff",
  inrangeExportTariff: "Spill export tariff",
  landlordLeaseRevenueShare: "Landlord Lease Revenue Share",
  landlordLicenseRevenueShare: "Landlord License Revenue Share",
  ownerOccupierLicenseRevenueShare: "Owner Occupier License Revenue Share",
  pvDesignSystemLastUpdatedAt: "PV Design System Last Updated At",
  pvDesignSystemLastUpdatedBy: "PV Design System Last Updated By",
  ownerOccupierLicenseInRangeSaasTariffRate:
    "Owner Occupier InRange SaaS Tariff Rate",
  demandCoefficientKWhPerM2: "Demand Coefficient (kWh/m²)",
  existingPvKwp: "Existing solar (kWp)",
  buildingProfile: "Building Profile",
  tenantEnergyShare: "Tenant Energy Share",
  investmentModel: "Investment Model (Selected)",
  activeInvestmentModel: "Investment Model (Active)",
  ghi: "GHI",
  hubspotUpdateTime: "Hubspot Update Time",
  hubspotRecordID: "HubSpot Record ID",
  installedCapacity: "Installed Capacity",
  tenantAnnualDemandKwh: "Demand (kWh)",
  demand: "Demand (kWh)",
  behindMeter: "Behind Meter (kWh)",
  curtailed: "Curtailed (kWh)",
  exported: "Exported (kWh)",
  generation: "Generation (kWh)",
  exportLimit: "Export Limit (kVA)",
  gridImport: "Grid Import (kWh)",
  networkImport: "Network Import (kWh)",
  networkExport: "Network Export (kWh)",
  batteryChargeLoss: "Battery Charge Loss (kWh)",
  energyFlowSummerDay: "Energy Flow Summer Day",
  energyFlowWinterDay: "Energy Flow Winter Day",
  hardware: "Hardware Cost",
  pvHardware: "PV Hardware Cost",
  batteryHardware: "Battery Hardware Cost",
  totalHardware: "Total Hardware Cost",
  installation: "Installation Cost",
  pvInstallation: "PV Installation Cost",
  batteryInstallation: "Battery Installation Cost",
  totalInstallation: "Total Installation Cost",
  total: "Total Cost",
  initialInvestment: "Total Upfront Capex",
  panel: "Panel Cost",
  mounting: "Mounting Cost",
  inverter: "Inverter Cost",
  electrical: "Electrical Cost",
  bos: "BOS Cost",
  misc: "Misc. Cost",
  insurance: "Insurance Cost (Lifetime)",
  insuranceYearOne: "Insurance Cost (Year 1)",
  maintenance: "Maintenance Cost (Lifetime)",
  maintenanceYearOne: "Maintenance Cost (Year 1)",
  licenseRevenue: "License Revenue",
  onSiteAvoidance: "On Site Avoidance",
  networkAvoidance: "Network Avoidance",
  totalAvoidance: "Emissions avoided year 1",
  generationAvoidance: "Generation Avoidance",
  networkImportTariff: "Network Import Tariff",
  blendedExportTariff: "Blended Export Tariff",
  ownerOccupierIRR: "Owner Occupier IRR",
  landlordIRR: "Landlord IRR",
  ownerOccupierPaybackMonths: "Owner Occupier Payback (Months)",
  landlordPaybackMonths: "Landlord Payback (Months)",
  "financialModels.landlord.license.revenue": "License: Landlord Revenue (Y1)",
  "financialModels.landlord.license.lifetimeRevenue":
    "License: Landlord Revenue (Lifetime)",
  "financialModels.landlord.license.inrangeNetRevenue":
    "License: Landlord InRange Revenue (Y1)",
  "financialModels.landlord.license.irr": "License: Landlord IRR",
  "financialModels.landlord.license.paybackMonths":
    "License: Landlord Payback (Months)",
  "financialModels.landlord.lease.revenue": "Lease: Landlord Revenue (Y1)",
  "financialModels.landlord.lease.lifetimeRevenue":
    "Lease: Landlord Revenue (Lifetime)",
  "financialModels.ownerOccupier.license.revenue":
    "License: Owner Occupier Revenue (Y1)",
  "financialModels.ownerOccupier.license.lifetimeRevenue":
    "License: Owner Occupier Revenue (Lifetime)",
  "financialModels.ownerOccupier.license.savings":
    "License: Owner Occupier Savings (Y1)",
  "financialModels.ownerOccupier.license.ppaSavings":
    "License: Owner Occupier Savings (over PPA length)",
  "financialModels.ownerOccupier.license.savingsPerPpa":
    "License: Owner Occupier Savings (over PPA length, per PPA)",
  "financialModels.ownerOccupier.license.lifetimeSavings":
    "License: Owner Occupier Savings (Lifetime)",
  "financialModels.ownerOccupier.license.inrangeNetRevenue":
    "License: Owner Occupier InRange Revenue (Y1)",
  "financialModels.ownerOccupier.license.irr": "License: Owner Occupier IRR",
  "financialModels.ownerOccupier.license.paybackMonths":
    "License: Owner Occupier Payback (Months)",
  "financialModels.ownerOccupier.lease.revenue":
    "Lease: Owner Occupier Revenue (Y1)",
  "financialModels.ownerOccupier.lease.lifetimeRevenue":
    "Lease: Owner Occupier Revenue (Lifetime)",
  "financialModels.ownerOccupier.lease.savings":
    "Lease: Owner Occupier Savings (Y1)",
  "financialModels.ownerOccupier.lease.ppaSavings":
    "Lease: Owner Occupier Savings (over PPA length)",
  "financialModels.ownerOccupier.lease.savingsPerPpa":
    "Lease: Owner Occupier Savings (over PPA length, per PPA)",
  "financialModels.ownerOccupier.lease.lifetimeSavings":
    "Lease: Owner Occupier Savings (Lifetime)",
  "financialModels.tenant.savings": "Tenant Savings (Y1)",
  "financialModels.tenant.ppaSavings": "Tenant Savings (over PPA length)",
  "financialModels.tenant.savingsPerPpa":
    "Tenant Savings (over PPA length, per PPA)",
  "financialModels.tenant.lifetimeSavings": "Tenant Savings (Lifetime)",
  "financialModels.procurement.costOnsitePV":
    "Tenant cost: On-site direct from PV",
  "financialModels.procurement.costOnsiteBattery":
    "Tenant cost: On-site from battery discharge",
  "financialModels.procurement.costOnsiteTariffArbitrage":
    "Tenant cost: Peak shifting",
  "financialModels.procurement.costNetworkImport":
    "Tenant cost: Network import",
  "financialModels.procurement.costTotal": "Tenant cost: Total cost",
  "financialModels.procurement.savings": "Savings",
  "financialModels.procurement.savingsPerPpa": "Savings per PPA",
  "financialModels.procurement.lifetimeSavings": "Lifetime Savings",
  "financialModels.ooLicenseProcurement.costOnsitePV":
    "OO-License: On-site direct from PV",
  "financialModels.ooLicenseProcurement.costOnsiteBattery":
    "OO-License: On-site from battery discharge",
  "financialModels.ooLicenseProcurement.costOnsiteTariffArbitrage":
    "OO-License: Peak shifting",
  "financialModels.ooLicenseProcurement.costNetworkImport":
    "OO-License: Network import",
  "financialModels.ooLicenseProcurement.costTotal": "OO-License: Total cost",
  "financialModels.ooLicenseProcurement.savings": "OO-License: Savings",
  "financialModels.ooLicenseProcurement.savingsPerPpa":
    "OO-License: Savings per PPA",
  "financialModels.ooLicenseProcurement.lifetimeSavings":
    "OO-License: Lifetime Savings",
  "financialModelsInrange.lease.netRevenue": "Lease: InRange Net Revenue (Y2)",
  "financialModelsInrange.lease.irr": "Lease: InRange Equity IRR",
  "financialModelsInrange.lease.paybackMonths":
    "Lease: InRange Debt Payback (Months)",
  "financialModelsInrange.lease.dscrMin": "Lease: InRange DSCR Min achieved",
  "financialModelsInrange.lease.dscrAvg": "Lease: InRange DSCR Avg achieved",
  "financialModelsInrange.lease.llcrMin": "Lease: InRange LLCR Min achieved",
  "financialModelsInrange.grossEnergyRevenue": "Gross Energy Revenue (Y1)",
  "financialModelsInrange.installArbitrage": "InRange Install Arbitrage",
  "costInputsInrange.enablingWorksCosts": "EW cost to DNO/others",
  "costInputsInrange.epcCostPerKWp": "InRange: EPC-only cost per kWp",
  "costInputsInrange.freeIssueCostPerKWp": "InRange: Free-issue cost per kWp",
  "costInputsInrange.constructionMonths": "Construction Months",
  "costInputsInrange.equityFraction": "Lease: InRange Equity Fraction",
  "costInputsInrange.interestRateConstruction":
    "Lease: InRange Interest Rate (Construction)",
  "costInputsInrange.interestRateOperationalFixed":
    "Lease: InRange Interest Rate Operational (Fixed)",
  "costInputsInrange.interestRateOperationalFixedTermYears":
    "Lease: InRange Interest Rate Operational (Fixed Term Years)",
  "costInputsInrange.interestRateOperationalVariable":
    "Lease: InRange Interest Rate Operational (Variable)",
  "costInputsInrange.loanTermYears": "Lease: InRange Loan Term (Years)",
  "costInputsInrange.vatRate": "Lease: InRange VAT Rate",
  "costInputsInrange.corporateTaxRate": "Lease: InRange Corporate Tax Rate",
  "costInputsInrange.commitmentFeeRate": "Lease: InRange Commitment Fee Rate",
  "costInputsInrange.arrangementFeeRate": "Lease: InRange Arrangement Fee Rate",
  "costInputsInrange.annualMonitoringFee":
    "Lease: InRange Annual Monitoring Fee",
  "costInputsInrange.annualMonitoringFeeRate":
    "Lease: InRange Annual Monitoring Fee Rate",
  "costInputsInrange.targetDscr": "Lease: InRange Target DSCR",
  "costInputsInrange.targetDscrMin": "Lease: InRange Target DSCR Min",
  "costInputsInrange.targetDscrAvg": "Lease: InRange Target DSCR Avg",
  "costInputsInrange.discountRate": "Lease: InRange Discount Rate",
  "costInputsInrange.targetLlcrMin": "Lease: InRange Target LLCR Min",
  "costInputsInrange.shapeInterestPayments":
    "Lease: InRange Shape Interest Payments",
  "costInputsInrange.debtPaybackDividendRate":
    "Lease: InRange Debt Payback Dividend Rate",
  initialCostPerKWp: "PV cost per kWp",
  totalCostPerKwp: "Total cost per kWp",
  panelCostPerKWp: "Panel Cost Per kWp",
  mountingCostPerKWp: "Mounting Cost Per kWp",
  inverterCostPerKWp: "Inverter Cost Per kWp",
  electricalCostPerKWp: "Electrical Cost Per kWp",
  bosCostPerKWp: "BOS Cost Per kWp",
  miscCostPerKWp: "Misc. Cost Per kWp",
  "costInputsPv.enablingWorksCosts": "EW cost to funder",
  wiringCosts: "Wiring Costs",
  hardwareCostPerKWp: "PV hw. cost per kWp",
  installationCostPerKWp: "PV installation Cost Per kWp",
  insuranceCostPerKWp: "Insurance Cost Per kWp",
  maintenanceCostPerKWp: "Maintenance Cost Per kWp",
  replacementCapex: "PV Replacement Capex",
  pvReplacementCapex: "PV Replacement Capex",
  replacementCapexRate: "PV Replacement Capex Rate",
  replacementCapexYear: "PV Replacement Capex Year",
  energyPriceInflationRate: "Energy Price Inflation Rate",
  costInflationRates: "Cost Inflation Rates",
  pvPanelName: "PV Panel Model",
  pvInverterBrand: "PV Inverter Brand",
  batteryPower: "Battery Power (MW)",
  "costInputsBattery.batterySpec.brand": "Battery Brand",
  "costInputsBattery.batterySpec.powerMw": "Battery Power (MW)",
  batteryCapacity: "Battery Capacity (MWh)",
  "costInputsBattery.batterySpec.capacityMwh": "Battery Capacity (MWh)",
  "costInputsBattery.batterySpec": "Battery Specification",
  "costInputsBattery.batterySpec.depthOfDischarge":
    "Battery Depth of Discharge",
  batteryModel: "Battery Model",
  batteryCost: "Battery Cost",
  "costInputsBattery.batterySpec.hardwareCost": "Battery HW cost to funder",
  "costInputsBattery.installationCost": "Battery Install cost to funder",
  "costInputsBattery.batterySpec.count": "Battery Count",
  "costInputsBattery.batterySpec.modelName": "Battery Model",
  "costInputsBattery.batterySpec.modelNotes": "Battery Model Notes",
  "costInputsBattery.batterySpec.roundTripEfficiency":
    "Battery Round Trip Efficiency",
  "costInputsBattery.batterySpec.warranty.capacity":
    "Battery End of Warranty Capacity",
  "costInputsBattery.batterySpec.warranty.periodCycles":
    "Battery Warranty Cycles",
  "costInputsBattery.batterySpec.warranty.periodYears":
    "Battery Warranty Years",
  // Mappings for batterySpec sub-fields (used in generation.N.batterySpec.*)
  "batterySpec.brand": "Battery Brand",
  "batterySpec.powerMw": "Battery Power (MW)",
  "batterySpec.capacityMwh": "Battery Capacity (MWh)",
  "batterySpec.depthOfDischarge": "Battery Depth of Discharge",
  "batterySpec.hardwareCost": "Battery HW cost to funder",
  "batterySpec.count": "Battery Count",
  "batterySpec.modelName": "Battery Model",
  "batterySpec.modelNotes": "Battery Model Notes",
  "batterySpec.roundTripEfficiency": "Battery Round Trip Efficiency",
  "batterySpec.warranty.capacity": "Battery End of Warranty Capacity",
  "batterySpec.warranty.periodCycles": "Battery Warranty Cycles",
  "batterySpec.warranty.periodYears": "Battery Warranty Years",
  // Mappings for cost fields (used in costInputsBattery.costs.<type>.*)
  installationCost: "Installation Cost",
  hardwareCost: "Hardware Cost",
  batteryReplacementYear: "Battery Replacement Capex Year",
  batteryReplacementCapex: "Battery Replacement Capex",
  sdmMatches: "SDM Matches",
  "sdmMatches.volume": "Volume",
  "sdmMatches.buyerId": "Site ID - Buyer",
  "sdmMatches.sellerId": "Site ID - Seller",
  "sdmMatches.buyerEsysUuid": "Site ID - Buyer esys ID",
  "sdmMatches.sellerEsysUuid": "Site ID - Seller esys ID",
  "sdmMatches.tariff": "Tariff",
  "tariffConfig.secondOnsitePpaConfig.tariff": "Second Onsite PPA Tariff",
  "tariffConfig.secondOnsitePpaConfig.ppaContractType":
    "Second Onsite PPA Contract Type",
  "tariffConfig.secondOnsitePpaConfig.ppaIndex": "Second Onsite PPA Index",
  "tariffConfig.secondOnsitePpaConfig.ppaType": "Second Onsite PPA Type",
  "tariffConfig.secondOnsitePpaConfig.ppaLength": "Second Onsite PPA Length",
  "tariffConfig.secondOnsitePpaConfig.nextPpa": "Second Onsite PPA Next PPA",
  "tariffConfig.secondOnsitePpaConfig": "Second Onsite PPA Config",
  "tariffConfig.peakDays": "Peak Days",
  "financialModels.marketPrice": "Market Price",
  "financialModels.ppaMarketPrice": "Market Price (over PPA length)",
  "financialModels.marketPricePerPpa":
    "Market Price (over PPA length, per PPA)",
  "financialModelsInrange.defaultRevenue.grossTenantCost": "Gross Tenant Cost",
  "financialModelsInrange.defaultRevenue.grossEnergyRevenue":
    "Gross Energy Revenue",
  "financialModelsInrange.defaultRevenue.grossEnergyRevenueExport":
    "Gross Energy Revenue - Export",
  "financialModelsInrange.defaultRevenue.grossEnergyRevenueOnsite":
    "Gross Energy Revenue - Onsite",
  "financialModelsInrange.ooLicenseRevenue.grossEnergyRevenue":
    "(OO-License) Gross Energy Revenue",
  "financialModelsInrange.ooLicenseRevenue.grossTenantCost":
    "(OO-License) Gross Tenant Cost",
  "financialModelsInrange.ooLicenseRevenue.grossEnergyRevenueExport":
    "(OO-License) Gross Energy Revenue - Export",
  "financialModelsInrange.ooLicenseRevenue.grossEnergyRevenueOnsite":
    "(OO-License) Gross Energy Revenue - Onsite",
  "financialModelsInrange.tariffArbitrageRevenue.grossTariffArbitrageValue":
    "Tariff Arbitrage Revenue - Gross Tenant Value",
  "financialModelsInrange.tariffArbitrageRevenue.grossEnergyRevenueArbitrage":
    "Tariff Arbitrage Revenue - Gross Energy Revenue",
  "financialModelsInrange.tariffArbitrageRevenue.grossProcurementValue":
    "Tariff Arbitrage Revenue - Gross Tenant Value",
  "financialModelsInrange.tariffArbitrageRevenue.grossRevenue":
    "Tariff Arbitrage Revenue - Gross Revenue",
  "tariffConfig.supplier.customFixedTariffs": "Custom Fixed Tariffs",
  "tariffConfig.supplier.customStandingCharges": "Custom Standing Charges",
  tariff: "PPA Tariff",
  volume: "Fixed Volume",
  contractEnergyPriceInflationRate:
    "Supplier Contract Energy Price Inflation Rate",
  contractLength: "Supplier Contract Length",
  ppaStartPoint: "PPA start point within Supplier contract",
  supplier: "Supplier",
  tariffPointFactorGsp: "Tariff Point Factor GSP",
  tariffPointFactorNbp: "Tariff Point Factor NBP",
  voltage: "Voltage",
  duosInflationRate: "DUoS Inflation Rate",
  days: "Days",
  endIndex: "End Index",
  startIndex: "Start Index",
  startYearDay: "Start Year Day",
  endYearDay: "End Year Day",
  "cft.tariff": "Tariff",
  "cft.inflation": "Inflation",
  "cft.isLossesCharge": "Is Losses Charge",
  "cft.tariffName": "Name",
  "cft.tariffPoint": "Tariff Point",
  "cft.volume": "Fixed Volume",
  "cft.tariffChargeType": "Tariff Charge Type",
  "cst.tariff": "Tariff",
  "cst.chargeName": "Charge Name",
  "cst.chargeType": "Charge Type",
  "cst.volume": "Fixed Volume",
  nextPpa: "PPA has next?",
  ppaContractType: "PPA Contract type",
  ppaType: "PPA Type",
  ppaIndex: "PPA Index",
  ppaLength: "PPA Length",
  exportPPAType: "Export PPA type",
  exportPPAIndex: "Export PPA index",
  exportPPALength: "Export PPA length",
  orgID: "Org ID",
  "siteOwnerships.ownership": "Org Site Ownership",
  park: "Org Park",
  "siteOwnerships.name": "Org Name",
  "siteOwnerships.isTest": "Org (is test org)",
  "buildings.geometry": "Building Geometry",
  "buildings.id": "Building ID",
  "buildings.polygonType": "Building Polygon Type",
  "buildings.sourcePolygonType": "Building Source Polygon Type",
  "buildings.surfaceAreaSqM": "Building Surface Area (m²)",
  operationalStatus: "Operational Status",
  "siteFiles.date": "Date",
  "siteFiles.description": "Description",
  "siteFiles.fileName": "File Name",
  "siteFiles.fileType": "File Type",
  "siteFiles.invoiceAmount": "Invoice Amount",
  "siteFiles.invoiceDueDate": "Invoice Due Date",
  "siteFiles.invoiceNumber": "Invoice Number",
  "siteFiles.isLandlord": "Is Landlord",
  "siteFiles.issueDate": "Issue Date",
  "siteFiles.statementAmount": "Statement Amount",
  "siteFiles.statementNumber": "Statement Number",
  isWired: "Wired?",
  systemLifetimeYears: "System Lifetime (Years)",
  flatAnnualCost: "Flat Annual Cost",
  roofRentPerM2: "Roof Rent Per m²",
  roofRentBtm: "Roof Rent BTM",
  roofRentExport: "Roof Rent Export",
  contingency: "Capex contingency (%)",
  contingencyOpex: "Opex contingency (%/year)",
  capitalisedCost: "Capitalized cost (%)",
  capitalisedInterest: "Capitalized interest (%)",
  vacancyLossRate: "Vacancy Loss Rate (%)",
  profileShape: "Profile Shape",
  profileDays: "Profile Days",
  pvCurve: "PV Curve",
  ghiSource: "GHI Source",
  weatherVersionTimestamp: "Weather Version Timestamp",
  overrideGHI: "Override GHI",
  score: "Site score",
  siteFiles: "Site Files",
  oAndMCostMode: "O&M Cost Application",
  "costInputsBattery.simVersion": "Battery Sim Version",
  "tariffConfig.enableDstShiftDemand": "Enable DST Shift Demand",
  "tariffConfig.arbitrageLeaseRevShare": "Arbitrage Lease Revenue Share",
  "tariffConfig.arbitrageLicenseRevShare": "Arbitrage License Revenue Share",
  "tariffConfig.arbitrageTenantShare": "Arbitrage Tenant Share",
  "tariffConfig.marketTariffOffPeak": "Market Tariff Off-Peak",
  "costInputsPv.inverters": "PV Inverters",
  "costInputsPv.inverterConfig": "PV Inverters config mode",
  "substationData.gsp_name": "Substation: Grid Supply Point",
  "substationData.bsp_name": "Substation: Bulk Supply Point",
  "substationData.name": "Substation: Primary Substation",
  "substationData.latitude": "Substation: Primary Substation Latitude",
  "substationData.longitude": "Substation: Primary Substation Longitude",
  "substationData.dno": "Substation: DNO Operator",
  "substationData.match_type": "Substation: Match type",
  "substationData.load_date": "Substation: Data load date",
  "substationData.scenario_name": "Substation: Scenario name",
  "substationData.scenario_year": "Substation: Scenario year",
  "substationData.headroom": "Substation: Generation Headroom",
  "tariffConfig.supplier.substationVersion": "Substation data version",
  pvPanelCount: "PV Panel Count",
  areaPct: "Area percentage",
  importGridConnectionId: "Import Grid Connection ID / MPAN",
  importMeterId: "Import Meter ID",
  exportGridConnectionId: "Export Grid Connection ID / MPRN",
  exportMeterId: "Export Meter ID",
};

export const formatFieldName = (
  lossFactorsByKey: Record<string, any>,
  fieldName: string
) => {
  // Handle generation.N.* fields
  const generationMatch = fieldName.match(/^generation\.(\d+)\.(.+)$/);
  if (generationMatch) {
    const [, index, subField] = generationMatch;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `Gen. idx ${index}: ${formattedSubField}`;
  }

  // Handle demand.N.* fields
  const demandMatch = fieldName.match(/^demand\.(\d+)\.(.+)$/);
  if (demandMatch) {
    const [, index, subField] = demandMatch;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `Dem. idx ${index}: ${formattedSubField}`;
  }

  // Handle battery.N.* fields
  const batteryMatch = fieldName.match(/^battery\.(\d+)\.(.+)$/);
  if (batteryMatch) {
    const [, index, subField] = batteryMatch;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `Bat. idx ${index}: ${formattedSubField}`;
  }

  // Handle esys.N.* fields
  const siteEsys = fieldName.match(/^esys\.(\d+)\.(.+)$/);
  if (siteEsys) {
    const [, index, subField] = siteEsys;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `Site Match idx ${index}: ${formattedSubField}`;
  }

  // Handle costInputsBattery.costs.<batteryType>.* fields
  const costInputsBatteryMatch = fieldName.match(
    /^costInputsBattery\.costs\.([^.]+)\.(.+)$/
  );
  if (costInputsBatteryMatch) {
    const [, batteryType, subField] = costInputsBatteryMatch;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `${batteryType}: ${formattedSubField}`;
  }

  // Handle costInputsInrange.batteryCosts.<batteryType>.* fields
  const costInputsInrangeMatch = fieldName.match(
    /^costInputsInrange\.batteryCosts\.([^.]+)\.(.+)$/
  );
  if (costInputsInrangeMatch) {
    const [, batteryType, subField] = costInputsInrangeMatch;
    const formattedSubField = formatFieldName(lossFactorsByKey, subField);
    return `${batteryType}: Mfr: ${formattedSubField}`;
  }

  if (fieldName.startsWith("generationLossFactors.")) {
    const key = fieldName.replace("generationLossFactors.", "");
    return `Loss factor: ${lossFactorsByKey[key]?.label || fieldName}`;
  } else if (
    fieldName.startsWith(
      "halfHourlyGeneration.lossesAnnual.generationLossFactors."
    )
  ) {
    const key = fieldName.replace(
      "halfHourlyGeneration.lossesAnnual.generationLossFactors.",
      ""
    );
    return `Loss factor: ${lossFactorsByKey[key]?.label || fieldName}: Computed`;
  } else if (fieldName.startsWith("generationLossFactorsOverride.")) {
    const key = fieldName.replace("generationLossFactorsOverride.", "");
    return `Loss factor: ${lossFactorsByKey[key]?.label || fieldName}: Override`;
  } else if (ACTIVITY_LOG_MAP[fieldName]) {
    return ACTIVITY_LOG_MAP[fieldName];
  } else if (fieldName.indexOf(".") !== -1) {
    // For older fields we only have the friendly name mapped to the last part
    // of the changed field name path because we didn't use to include the full path.
    // This code handles falling back to the last part of the path.
    const lastFieldNamePart = fieldName.split(".").slice(-1)[0];
    if (ACTIVITY_LOG_MAP[lastFieldNamePart]) {
      const result = ACTIVITY_LOG_MAP[lastFieldNamePart];
      if (fieldName.startsWith("tariffConfig.onsitePPA")) {
        // Handle multiple PPAs
        const ppaNumber = countOccurrences(fieldName, "nextPpa") + 1;
        return result.replace("PPA", `Onsite PPA ${ppaNumber}`);
      }
      if (fieldName.startsWith("tariffConfig.spillExportPPA")) {
        // Handle multiple PPAs
        const ppaNumber = countOccurrences(fieldName, "nextPpa") + 1;
        return result.replace("PPA", `Spill Export PPA ${ppaNumber}`);
      }
      let tariffName: string | undefined = undefined;
      let tariffRateName: string | undefined = undefined;
      if (
        fieldName.startsWith(
          "tariffConfig.supplier.peakOffPeak.overrideRatesMap"
        )
      ) {
        tariffName = "Peak/Off-Peak";
        tariffRateName = "Off-Peak";
      } else if (fieldName.startsWith("tariffConfig.supplier.peakOffPeak")) {
        tariffName = "Peak/Off-Peak";
        tariffRateName = "Peak";
      } else if (
        fieldName.startsWith("tariffConfig.supplier.duos.overrideRatesMap.")
      ) {
        tariffName = "DUoS";
        const mapEntry = fieldName
          .replace("tariffConfig.supplier.duos.overrideRatesMap.", "")
          .split(".")[0];
        if (mapEntry === "red") {
          tariffRateName = "DUoS 1/Red";
        } else if (mapEntry === "amber") {
          tariffRateName = "DUoS 2/Amber";
        } else {
          tariffRateName = `DUoS ${mapEntry}`;
        }
      } else if (fieldName.startsWith("tariffConfig.supplier.duos.")) {
        tariffName = "DUoS";
        tariffRateName = "DUoS 3/Green";
      } else if (
        fieldName.startsWith(
          "tariffConfig.supplier.standardSingleRateTimedTariffs."
        )
      ) {
        tariffName = fieldName
          .replace("tariffConfig.supplier.standardSingleRateTimedTariffs.", "")
          .split(".")[0];
      } else if (
        fieldName.startsWith("tariffConfig.supplier.standardFixedTariffs.")
      ) {
        tariffName = fieldName
          .replace("tariffConfig.supplier.standardFixedTariffs.", "")
          .split(".")[0];
      } else if (
        fieldName.startsWith("tariffConfig.supplier.standardStandingCharges.")
      ) {
        tariffName = fieldName
          .replace("tariffConfig.supplier.standardStandingCharges.", "")
          .split(".")[0];
      }
      let tariffRateRangeName: string | undefined = undefined;
      if (fieldName.includes(".rangesMap.")) {
        tariffRateRangeName = fieldName.split(".rangesMap.")[1].split(".")[0];
      }
      if (tariffName !== undefined) {
        return `${tariffName} ${tariffRateName !== undefined ? ` ${tariffRateName}` : ""}${tariffRateRangeName !== undefined ? ` Range ${tariffRateRangeName}` : ""} ${result.replace("PPA", " ")}`;
      }
      return result;
    }
  }
  // If a friendly name has not been provided, render the raw field path
  return fieldName;
};

function countOccurrences(haystack: string, needle: string): number {
  if (needle === "") return 0; // avoid infinite loop
  return haystack.split(needle).length - 1;
}
